import { RegulationModel } from "./regulation.model";

export class RuleVersionHistory{
    id: number;
    versionNumber: number;
    versionDate: Date;
    constructor() {
        this.id = 0;
        this.versionNumber = 0;
        this.versionDate = new Date();
    }
}
export class RuleVersionHistoryModel{
    data: RuleVersionHistory[];
    totalCount: number;

    constructor() {
        this.data = [];
        this.totalCount = 0;
    }
}
export class RuleVersionFilterViewModel {
    regulation: RegulationModel;
    versionId: number;
    filterType: string;

    constructor() {
        this.regulation = new RegulationModel();
        this.versionId = 0;
        this.filterType = '';
    }
}
export class VersionRegulationModel{
    versionData: RegulationModel;
    isChanged:boolean;
    constructor() {
        this.versionData = new RegulationModel();
        this.isChanged = false;
    }
}